export default __webpack_public_path__ + "static/media/no-data.337538fd.svg";